export default __webpack_public_path__ + "static/media/no_image.3f37e96d.png";